export default __webpack_public_path__ + "static/curtain-b6a006ca88472cdb49a76cbcd8937657.webp";